import { render, staticRenderFns } from "./MealBreakRequestApproved.vue?vue&type=template&id=644f45ed&"
import script from "./MealBreakRequestApproved.vue?vue&type=script&lang=js&"
export * from "./MealBreakRequestApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports